import Block from './Block'
import TweenMax from 'gsap/TweenMax'

export default class Title extends Block {
  constructor(el, destroyLast) {
    super(el, destroyLast)
    this.splittedTitle = null

    this.split()
  }

  bindMethods() {
    super.bindMethods()
    this.split = this.split.bind(this)
    this.wrap = this.wrap.bind(this)
  }

  getElems() {
    super.getElems()
    this.title = this.el
    if (this.el.classList.contains('js-observer')) {
      this.titleFull = this.el.querySelector('.heading__full')
      this.titleStroke = this.el.querySelector('.heading__stroke')
    }
  }

  events() {
    super.events()
  }

  split() {
    if (!this.titleFull) return

    this.splittedTitle = new SplitText(this.titleFull, {
      type: 'words, chars',
      charsClass: 'char'
    })

    this.splittedTitleStroke = new SplitText(this.titleStroke, {
      type: 'words, chars',
      charsClass: 'char'
    })

    this.wrap()
  }

  wrap() {
    for (let i = 0; i < this.splittedTitle.chars.length; i++) {
      const inner = this.splittedTitle.chars[i].innerHTML

      this.splittedTitle.chars[i].innerHTML = '<span>' + inner + '</span>'
    }

    for (let i = 0; i < this.splittedTitleStroke.chars.length; i++) {
      const inner = this.splittedTitleStroke.chars[i].innerHTML

      this.splittedTitleStroke.chars[i].innerHTML = '<span>' + inner + '</span>'
    }

    this.setInitialPosition()
  }

  setInitialPosition() {
    const titleFullChars = this.titleFull.querySelectorAll('.char > span')
    const titleStrokeChars = this.titleStroke.querySelectorAll('.char > span')

    TweenMax.set(titleFullChars, { x: '-100%' })
    TweenMax.set(titleStrokeChars, { x: '-100%' })
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Title.js